/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    IWafPolicyAllowlist,
    IWafPolicyAllowlistRule,
} from 'generated-types';
import {
    MessageItem,
    RepeatedMessageItem,
} from 'ajs/modules/data-model/factories';
import {
    withEditChildMessageItemMixin,
} from 'ajs/modules/data-model/mixins/with-edit-child-message-item.mixin';
import { WafPolicyAllowlistRuleConfigItem } from './waf-policy-allowlist-rule.config-item.factory';

type TWafPolicyAllowlist = Omit<IWafPolicyAllowlist, 'rules'>;

interface IWafPolicyAllowlistConfig extends TWafPolicyAllowlist {
    rules?: RepeatedMessageItem<WafPolicyAllowlistRuleConfigItem>;
}

export const WAF_POLICY_ALLOWLIST_CONFIG_ITEM_TOKEN = 'WafPolicyAllowlistConfigItem';

export class WafPolicyAllowlistConfigItem extends
    withEditChildMessageItemMixin(MessageItem)<IWafPolicyAllowlistConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'WafPolicyAllowlist',
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    public canFlatten(): boolean {
        return !this.config.rules.isEmpty();
    }

    /**
     * Returns the number of rules in the config.
     */
    public getRulesCount(): number {
        return this.config.rules.count;
    }

    /**
     * Returns a new WafPolicyAllowlistRule ConfigItem instance.
     */
    public createNewRule(config: IWafPolicyAllowlistRule = null): WafPolicyAllowlistRuleConfigItem {
        return this.createChildByField_('rules', config, true) as WafPolicyAllowlistRuleConfigItem;
    }

    /**
     * Edits an allowlist rule.
     */
    public editRule(rule: WafPolicyAllowlistRuleConfigItem): void {
        this.editChildMessageItem({
            field: 'rules',
            messageItem: rule,
            modalBindings: {
                editMode: true,
            },
        });
    }

    /**
     * Opens Child odal to add an new allowlist rule.
     */
    public addNewRule(): void {
        this.addChildMessageItem({
            field: 'rules',
        });
    }
}
